'use client';

import H1 from '@/components/typography/h1';
import Label from '@/components/typography/label';
import P from '@/components/typography/p';
import { Button } from '@/components/ui/button';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

export default function BusinessAsAForce() {
    const { t } = useTranslation();

    return (
        <>
            {/* Desktop view */}
            <div className="hidden lg:block">
                <div className="border-primary relative flex flex-col items-center justify-center gap-5 border-b px-6 py-[12.9rem]">
                    <div className="grid grid-cols-[5fr_7fr] items-center gap-3">
                        <div className="relative -z-10 flex size-full items-center">
                            <Image
                                src="/images/stickers/appel.png"
                                alt="Good Food"
                                className="absolute aspect-square translate-y-14 object-right"
                                width={1024}
                                height={1024}
                            />
                        </div>
                        <div className="flex max-w-5xl flex-col gap-5 pr-[10.5rem]">
                            <H1>{t('businessAsAForce.title')}</H1>
                            <P
                                variant="large"
                                dangerouslySetInnerHTML={{
                                    __html: t('businessAsAForce.subtitle'),
                                }}
                            />
                            <Link href="/b-corp" className="w-fit">
                                <Button
                                    variant={'ghost'}
                                    className="mt-4 -ml-4 w-fit hover:cursor-pointer"
                                >
                                    <Label
                                        variant="button"
                                        className="underline"
                                    >
                                        {t('businessAsAForce.buttonText')}
                                    </Label>
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* Mobile view */}
            <div className="block lg:hidden">
                <div className="border-primary relative flex flex-col items-center justify-center gap-5 border-b px-5 py-15">
                    <div className="flex flex-col gap-5">
                        <H1>{t('businessAsAForce.title')}</H1>
                        <P
                            variant="large"
                            dangerouslySetInnerHTML={{
                                __html: t('businessAsAForce.subtitle'),
                            }}
                        />
                        <div className="mt-5">
                            <Link href="/b-corp">
                                <Button className="w-fit">
                                    <Label
                                        variant="button"
                                        className="underline"
                                    >
                                        {t('businessAsAForce.buttonText')}
                                    </Label>
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
